var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:({'margin-bottom': _vm.bottom}),attrs:{"fluid":(_vm.fluid || _vm.isFluid)}},[_c('v-row',{attrs:{"dense":"","justify":_vm.justify}},[_c('v-col',_vm._b({attrs:{"cols":_vm._cols.cols}},'v-col',_vm.$attrs,false),[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }